<template>
  <header>
    <nav class="navbar">
      <div class="container">
        <router-link to="/" class="logo">
          <img src="/assets/img/logo-trans.png" alt="Space Coast STEM Logo" class="logo-icon">
          <div >
            <span class="logo-space">Space Coast</span>
            <span class="logo-stem">STEM</span>
          </div>
        </router-link>
        <ul class="nav-menu" :class="{ active: mobileMenuOpen }">
          <li><router-link to="/" @click="closeMobileMenu">Home</router-link></li>
          <li><router-link to="/about" @click="closeMobileMenu">About</router-link></li>
          <li><router-link to="/get-involved" @click="closeMobileMenu">Get Involved</router-link></li>
          <li><router-link to="/support" @click="closeMobileMenu">Support</router-link></li>
          <li><router-link to="/contact" @click="closeMobileMenu">Contact</router-link></li>
          <li><router-link to="/donate" class="btn-donate" @click="closeMobileMenu">Donate</router-link></li>
        </ul>
        <div class="hamburger" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const mobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}
</script>

<style scoped>
/* Header and Navigation */
header {
  background: var(--white, #ffffff);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar {
  padding: 1rem 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
}

.logo-icon {
  width: 80px;
  height: 80px;
  transition: transform 0.3s ease;
}

.logo:hover .logo-icon {
  transform: translateY(-3px);
}

.logo-text {
  color: var(--text-dark, #333333);
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.logo-space {
  font-size: 0.9em;
  font-weight: 600;
  color: var(--text-dark, #333333);
  letter-spacing: 0.5px;
}

.logo-stem {
  font-size: 1.1em;
  font-weight: 800;
  color: var(--text-dark, #333333);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
  align-items: center;
}

.nav-menu a {
  text-decoration: none;
  color: var(--text-dark, #333333);
  font-weight: 500;
  transition: color 0.3s;
}

.nav-menu a:hover,
.nav-menu a.router-link-active {
  color: var(--primary-color, #2c4a6b);
}

.btn-donate {
  background: var(--accent-color, #e94f3a);
  color: var(--white, #ffffff) !important;
  padding: 0.5rem 1.5rem;
  border-radius: 25px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.btn-donate:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
}

.hamburger span {
  width: 25px;
  height: 3px;
  background: var(--text-dark, #333333);
  margin: 3px 0;
  transition: 0.3s;
}

/* Responsive Design */
@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    left: -100%;
    top: 110px;
    flex-direction: column;
    background: var(--white, #ffffff);
    width: 100%;
    text-align: center;
    transition: 0.3s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 2rem 0;
  }

  .nav-menu.active {
    left: 0;
  }
}
</style>
